import React from 'react';
import Switch from '@mui/material/Switch';
import { useCurrentDebrief, useAnalytics } from 'ff/debrief/hooks';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const DebriefScoreToggle = () => {
    const { saveDebriefSettings, isScoreModeEnabled } = useCurrentDebrief();
    const { logNonScoredModeToggled } = useAnalytics();

    const handleToggle = (event: { target: { checked: boolean } }) => {
        saveDebriefSettings({ isScoreModeEnabled: event.target.checked });
        logNonScoredModeToggled({
            toggledState: event.target.checked ? 'On' : 'Off',
        });
    };

    return (
        <Stack direction="row" spacing={3} sx={{ alignItems: 'center' }}>
            <Typography color="text.primary">Debrief Score</Typography>
            <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
                <Typography color="text.secondary">OFF</Typography>
                <Switch
                    checked={isScoreModeEnabled}
                    onChange={handleToggle}
                    color="primary"
                />
                <Typography color="text.secondary">ON</Typography>
            </Stack>
        </Stack>
    );
};

export default DebriefScoreToggle;
